export const OPEN_AGENT_POPUP = 'OPEN_AGENT_POPUP';
export const CLOSE_AGENT_POPUP = 'CLOSE_AGENT_POPUP';

// Chat state management
export const ADD_MESSAGE = 'ADD_MESSAGE';
export const SET_MESSAGES = 'SET_MESSAGES';
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES';
export const UPDATE_MESSAGE = 'UPDATE_MESSAGE';

// Conversation pairs management
export const ADD_CONVERSATION_PAIR = 'ADD_CONVERSATION_PAIR';
export const SET_CONVERSATION_PAIRS = 'SET_CONVERSATION_PAIRS';
export const CLEAR_CONVERSATION_PAIRS = 'CLEAR_CONVERSATION_PAIRS';

// Workspace options management
export const SET_WORKSPACE_OPTIONS = 'SET_WORKSPACE_OPTIONS';
export const SET_WORKSPACE_OPTIONS_LOADING = 'SET_WORKSPACE_OPTIONS_LOADING';
export const SET_WORKSPACE_OPTIONS_LOADED = 'SET_WORKSPACE_OPTIONS_LOADED';

// Session management
export const SET_CHAT_STEP = 'SET_CHAT_STEP';
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS';
export const SET_FIRST_RECOMMENDATION_DISPLAYED = 'SET_FIRST_RECOMMENDATION_DISPLAYED';
export const SET_INITIAL_MESSAGE_SET = 'SET_INITIAL_MESSAGE_SET';
export const SET_HAS_AUTO_FETCHED = 'SET_HAS_AUTO_FETCHED';

// Loading states
export const SET_LOADING = 'SET_LOADING';
export const SET_INITIAL_LOADING = 'SET_INITIAL_LOADING';

// Contact form management
export const SET_CONTACT_FORM = 'SET_CONTACT_FORM';
export const SET_SHOW_CONTACT_FORM = 'SET_SHOW_CONTACT_FORM';

// Chat session management
export const RESET_CHAT_SESSION = 'RESET_CHAT_SESSION';
export const CLEAR_CHAT_SESSION = 'CLEAR_CHAT_SESSION';

// Space and event IDs management
export const SET_SPACE_IDS = 'SET_SPACE_IDS';
export const SET_EVENT_IDS = 'SET_EVENT_IDS';
export const ADD_SPACE_ID = 'ADD_SPACE_ID';
export const ADD_EVENT_ID = 'ADD_EVENT_ID';

// User data management
export const FETCH_USER_DATA_REQUEST = 'FETCH_USER_DATA_REQUEST';
export const FETCH_USER_DATA_SUCCESS = 'FETCH_USER_DATA_SUCCESS';
export const FETCH_USER_DATA_FAILURE = 'FETCH_USER_DATA_FAILURE';
export const CLEAR_USER_DATA = 'CLEAR_USER_DATA';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'; 